import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { InternalTrainingVM } from "@shared-kernel/application/ports/admin/admin-repository";

export const adminRetrieveInternalTrainings = createAsyncThunk<InternalTrainingVM[], void, { extra: Partial<Dependencies> }>(
  "internalTrainings/retrieveInternalTrainings",
  async (_, { extra: { adminRepository } }) => {
    return adminRepository!.listInternalTrainings();
  },
);

export const resetAdminRetrieveInternalTrainings = createAction("internalTrainings/resetAdminRetrieveInternalTrainings");
